export default "__VITE_ASSET__D96m5V9g__"